<template>
    <div class="modal modal-slide-in new-user-modal fade" id="modals-fax">
        <div class="modal-dialog">
            <form v-on:submit="sendFax" class="add-new-user modal-content pt-0" enctype="multipart/form-data" method="post" >
                <button type="button" @click="closeModal('#modals-fax')" class="close" data-dismiss="modal" aria-label="Close">×</button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title">
                        {{ localizationStore.translate("fax.letter.modal.title") }}
                    </h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="form-group">
                        <label class="form-label" for="basic-icon-default-fullname">
                            {{ localizationStore.translate("fax.letter.modal.input.label.one") }}
                        </label>
                        <phone-input-component @phoneInput="updatePhone" name="fax-number" :prop-phone="phone" />
                    </div>
                    <b-form-checkbox
                        v-model="coverSheet"
                        checked="true"
                        name="cover-sheet"
                        switch
                    >
                        {{ localizationStore.translate("fax.letter.modal.input.label.two") }}
                    </b-form-checkbox>
                    <div class="mt-1">
                        <template v-if="coverSheet">
                            <div class="form-group">
                                <label for="receiver-name">
                                    {{ localizationStore.translate("fax.letter.modal.input.label.three") }}
                                </label>
                                <input
                                    v-model="receiverName"
                                    type="text"
                                    class="form-control"
                                    :placeholder="localizationStore.translate('fax.letter.modal.input.placeholder.three')"
                                    name="receiver-name"
                                >
                            </div>
                            <div class="form-group">
                                <label for="subject">
                                    {{ localizationStore.translate("fax.letter.modal.input.label.four") }}
                                </label>
                                <input
                                    v-model="subject"
                                    type="text"
                                    class="form-control"
                                    :placeholder="localizationStore.translate('fax.letter.modal.input.label.placeholder.four')"
                                    name="subject"
                                >
                            </div>
                            <div class="form-group">
                                <label for="cover-sheet-message">
                                    {{ localizationStore.translate("fax.letter.modal.input.label.five") }}
                                </label>
                                <textarea
                                    v-model="coverSheetMessage"
                                    name="cover-sheet-message"
                                    class="form-control"
                                    rows="3"
                                    :placeholder="localizationStore.translate('fax.letter.modal.input.label.placeholder.five')"
                                ></textarea>
                            </div>
                        </template>
                    </div>
                    <div class="mt-1">
                        <button type="submit" id="submit" name="submit" class="btn btn-sm btn-primary mr-1 data-submit">
                            {{ localizationStore.translate("fax.letter.modal.input.button.one.text") }}
                        </button>
                        <button type="button" @click="preview" class="btn btn-sm btn-outline-primary mr-1">
                            {{ localizationStore.translate("fax.letter.modal.input.button.two.text") }}
                        </button>
                        <button type="reset" @click="closeModal('#modals-fax')" class="btn btn-sm btn-outline-danger" data-dismiss="modal">
                            {{ localizationStore.translate("fax.letter.modal.input.button.three.text") }}
                        </button>
                    </div>
                    <h4 class="mt-4">
                        {{ localizationStore.translate("fax.letter.modal.heading.text") }}
                    </h4>
                    <div v-for="(fax,index) in disputeLetterStore.faxNumber">
                        <span style="font-weight:bolder;">{{ fax.name }} :</span> {{ fax.fax_number }}
                    </div>
                    <br>
                    <p> <span class="text-danger fw-bold" style="font-weight:bolder;">DISCLAIMER:</span> Credit Bureau fax numbers change often. Please verify the numbers are correct by doing a quick google search. Here’s an example: “What’s Experian’s fax number for disputes”. </p>
                    <div>
                        <h6 style="font-weight:bolder;">
                            Can you fax?
                        </h6>
                        <p>
                            Yes absolutely. But mailing documents to Credit Bureaus by postal mail is the more reliable way to accomplish this.
                        </p>

                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="scrolling-inside-modal">
        <div class="modal fade" id="preview-fax" tabindex="-1" role="dialog" aria-labelledby="previewFax" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ localizationStore.translate("fax.letter.preview.modal.heading.text") }}
                        </h5>
                        <button @click="closeModal('#preview-fax')" type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-html="faxPreview">
                    </div>
                    <div class="modal-footer align-center">
                        <button @click="closeModal('#preview-fax')" type="button" class="btn btn-primary" data-dismiss="modal">
                            {{ localizationStore.translate("fax.letter.preview.modal.input.button.one.text") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref } from 'vue';
    import PhoneInputComponent from './PhoneInputComponent'
    import { useLoading } from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { closeModal, openModal } from '../utilities/_helpers'
    import { useLocalizationStore } from '../stores/LocalizationStore.js'
    import { useDisputeLetterStore } from '../stores/DisputeLetterStore.js'
    export default {
        components: {
            PhoneInputComponent
        },
        setup(props) {
            return {
                creditorName: ref(null),
                phone: ref(null),
                letterUser: ref(null),
                coverSheet: ref(false),
                faxPreview: ref(null),
                fullPage: ref(false),
                receiverName: ref(null),
                subject: ref(null),
                coverSheetMessage: ref(null),
                loader: ref(null),
                loading: useLoading(),
                closeModal: closeModal,
                openModal: openModal,
                localizationStore: useLocalizationStore(),
                disputeLetterStore: useDisputeLetterStore(),
            };
        },
        created() {
            this.initialize()
        },
        methods: {
            initialize: function() {
                let $this = this;
                $(document).on('hidden.bs.modal','#modals-fax', function () {
                    $this.resetForm();
                });
            },
            sendFax: function(e) {
                e.preventDefault();
                const route = this.$router.resolve(
                    {
                        name: 'fax-send',
                        params: {
                            letterUser: this.letterUser,
                            client: this.$route.params.client,
                            team: this.$route.params.team,
                        }
                    }
                );
                const $this = this;
                $this.loader = $this.loading.show({
                    color: '#4b9a5e',
                    loader: 'spinner',
                    width: 64,
                    height: 64,
                });
                axios.post(
                    route.href,
                    {
                        'fax-number': this.phone,
                        'cover-sheet': this.coverSheet,
                        'receiver-name': this.receiverName,
                        'subject': this.subject,
                        'cover-sheet-message': this.coverSheetMessage
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        $this.loader.hide();
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    $this.loader.hide();
                    closeModal('#modals-fax');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },
            preview: function(e) {
                e.preventDefault();
                let $this = this;
                const route = this.$router.resolve(
                    {
                        name: 'fax-send',
                        params: {
                            letterUser: this.letterUser,
                            client: this.$route.params.client,
                            team: this.$route.params.team,
                        }
                    }
                );
                axios.post(
                    route.href,
                    {
                        'fax-number': this.phone,
                        'cover-sheet': this.coverSheet,
                        'receiver-name': this.receiverName,
                        'subject': this.subject,
                        'cover-sheet-message': this.coverSheetMessage,
                        'type': 'preview'
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.faxPreview = response.data.data.letter_preview;
                    openModal('#preview-fax');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },
            openFaxModal(letter) {
                const $this = this;
                $this.letterUser = letter.id;
                $this.creditorName = letter.credit_bureau_name;
                const route = $this.$router.resolve(
                    {
                        name: 'fax-number',
                        params: {
                            client: $this.$route.params.client,
                            team: $this.$route.params.team,
                        }
                    }
                );
                axios.get(
                    route.href,
                    {
                        params: {
                            creditorName: $this.creditorName
                        }
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.phone = response.data.data == null ? "" : response.data.data;
                    openModal('#modals-fax');
                }).catch(function(error) {
                    setTimeout(() => {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            },
            resetForm() {
                this.coverSheet = false;
                this.receiverName = null;
                this.subject = null;
                this.coverSheetMessage = null;
            },
            updatePhone(phone) {
                this.phone = phone;
            },
        },
        beforeMount() {

        }
    };
</script>
